import axios from 'axios';

import urls from '../../utils/urls';
import {tokenHeader} from '../../utils/headers';

export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_IN_ERROR = 'USER_LOGGED_IN_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_TOKEN_EXPIRED = 'USER_TOKEN_EXPIRED';


export function loginUser(username, password) {
    return (dispatch) => {
        const login_url = `${urls.API_ROOT}/api/v1/login/`;
        axios
            .post(login_url, {}, {auth: {username: username, password: password}})
            .then((response) => dispatch(userLoggedIn(response.data)))
            .catch((error) => {
              dispatch(userErrorLogIn())
            });
    }
}

export function userLoggedIn(payload) {
    let data = payload;
    data.canModifyPublic = false;
    data.canModifyPrivate = false;
    data.canSeeSimulator = false;
    data.canDefineStrategy = false;
    if(data.roles instanceof Array){
        data.roles.forEach(r => {
            if(r === "Pricing Staff"){
                data.canModifyPublic |= true;
                data.canModifyPrivate |= false;
                data.canSeeSimulator |= true;
                data.canDefineStrategy |= true;
            }else if(r === "Administrator"){
                data.canModifyPublic |= true;
                data.canModifyPrivate |= true;
                data.canSeeSimulator |= true;
                data.canDefineStrategy |= true;
            }else{
                data.canModifyPublic |= false;
                data.canModifyPrivate |= true;
                data.canSeeSimulator |= false;
                data.canDefineStrategy |= false;
            }
        })
    }else{
        if(data.roles === "Pricing Staff"){
            data.canModifyPublic |= true;
            data.canModifyPrivate |= false;
            data.canSeeSimulator |= true;
            data.canDefineStrategy |= true;
        }else if(data.roles === "Administrator"){
            data.canModifyPublic |= true;
            data.canModifyPrivate |= true;
            data.canSeeSimulator |= true;
            data.canDefineStrategy |= true;
        }else{
            data.canModifyPublic |= false;
            data.canModifyPrivate |= true;
            data.canSeeSimulator |= false;
            data.canDefineStrategy |= false;
        }
    }
    return {
        type: USER_LOGGED_IN,
        payload: data
    };
}

export function userErrorLogIn(){
    return {
        type: USER_LOGGED_IN_ERROR
    };
}

export function validateToken() {
    // Will only validate token, if is not from today
    let user = localStorage.getItem('activeUser');
    let data = JSON.parse(user);
    let yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000).getTime();
    if(data['token_date'] > yesterday){
        return {type: ''};
    }

    return (dispatch) => {

        const validate_token_url = `${urls.API_ROOT}/api/v1/validate-token/`;
        axios
            .get(validate_token_url, tokenHeader())
            .then((response) => dispatch(userLoggedIn(response.data)))
            .catch((error) => dispatch(userTokenExpired()));
    }
}

export function userTokenExpired(){
    return {
        type: USER_TOKEN_EXPIRED
    }
}


export function logoutUser() {

    const logout_url = `${urls.API_ROOT}/api/v1/logout/`;
    axios.post(logout_url, {}, tokenHeader());

    return {
        type: USER_LOGOUT
    }

}



// WEBPACK FOOTER //
// ./src/actions/user_actions/index.js